import { render, staticRenderFns } from "./AzSocietiesTopSlot.vue?vue&type=template&id=c12be094"
import script from "./AzSocietiesTopSlot.vue?vue&type=script&lang=js"
export * from "./AzSocietiesTopSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports